import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { AppsSearchRequestDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";
import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

const FIND_APPS_QUERY_KEY = "find-apps";

const FIND_APPS_COLUMN_CONFIG_QUERY_KEY = "find-apps:column-config";

interface IFindAppsQueryKeyFactory extends QueryKeyFactory {
    appData(sourceType: AppsSourceType, dto?: AppsSearchRequestDto): readonly unknown[];

    columnConfig(sourceType: AppsSourceType): readonly string[];
}

export const findAppsQueryKeyFactory: IFindAppsQueryKeyFactory = {
    appData(sourceType: AppsSourceType, dto?: AppsSearchRequestDto): unknown[] {
        const key = `${FIND_APPS_QUERY_KEY}:${sourceType}`;

        if (is.undefined(dto)) {
            return [key];
        }

        return [key, dto];
    },

    columnConfig(sourceType: AppsSourceType): readonly string[] {
        return [FIND_APPS_COLUMN_CONFIG_QUERY_KEY, sourceType];
    },
};
